<script setup>
import { useGetManualQuery } from '~/composables/urql';
import GuidesPlant from '~/components/Guides/Editorial.vue';
import { findGuide } from '~/utils/guides/registry.mjs';
import { phases as tomatoPhases } from '~/data/guides/tomato-practical.mjs';
import {legacyGiantTarget} from '~/utils/guides/pumpkin-route.mjs';
import { cropSchema, guideMetadata, serializeSchema, guideUrl } from '~/utils/guides/schema.mjs';
definePageMeta({key: route => route.path});
const route=useRoute();
const { params: variables } = route;
if(variables.slug==='tykva') {
 const target=legacyGiantTarget(route.query);
 if(target)await navigateTo(target,{redirectCode:301});
}
const editorial = findGuide(variables.slug);
const { data, error } = editorial?.parentSlug ? {data:ref(null),error:ref(null)} : await useGetManualQuery({variables});
if (!editorial && error.value && !data.value) throw createError({statusCode:503,statusMessage:'Guide temporarily unavailable'});
const manual = computed(() => data.value?.uogorod_view_manual?.[0]);
if (!editorial && !manual.value) throw createError({statusCode:404,statusMessage:'Guide not found'});
const guide = computed(() => editorial);
const feedbackPhases = computed(() => !guide.value ? [] : guide.value.slug === 'tomat' ? tomatoPhases : guide.value.phases);
onMounted(()=>{if(variables.slug==='tykva'){const target=legacyGiantTarget(route.query,route.hash);if(target)navigateTo(target,{replace:true});}});
useSeoMeta({title:() => guide.value ? guideMetadata(guide.value).title : `${manual.value?.category.title} — руководство по выращиванию`,description:() => guide.value ? guideMetadata(guide.value).description : `Выращивание ${manual.value?.category.title}: посадка и уход.`});
useHead(() => guide.value ? {
  link:[{key:'canonical', rel:'canonical', href:guideUrl(guide.value.slug)}],
  script:[{key:'guides-schema', type:'application/ld+json', innerHTML:serializeSchema(cropSchema(guide.value, guide.value.slug === 'tomat' ? tomatoPhases : guide.value.phases))}]
} : {script:[]});
</script>
<template><div><GuidesPumpkinSwitch v-if="guide && ['tykva','tykva-gigantskaya'].includes(guide.slug)" :slug="guide.slug"/><GuidesPlant v-if="guide" :key="guide.slug" :guide="guide"/><Manual v-else :manual="manual"/><GuidesFeedback v-if="guide" :key="'feedback-'+guide.slug" :guide="guide" :phases="feedbackPhases"/></div></template>
